export const getHistoricalDataTool = {
  functionDeclarations: [{
    name: "getHistoricalData",
    description: "Fetches historical financial data (Revenue, SMRS Fees, Expenses, Net Profit) for the past 3 months. Use this when you need past months' performance, trends, projections, or fixed costs analysis.",
    parameters: {
      type: "OBJECT",
      properties: {
        companyName: {
          type: "STRING",
          description: "Optional. The exact name of the company to filter historical data for. If omitted, returns data for all companies."
        }
      }
    }
  }]
};

export const getCurrentPeriodDataTool = {
  functionDeclarations: [{
    name: "getCurrentPeriodData",
    description: "Fetches detailed financial data specifically for the current statement period. Use this for questions about current month's performance, expenses, or profit.",
    parameters: {
      type: "OBJECT",
      properties: {
        companyName: {
          type: "STRING",
          description: "Optional. The exact name of the company to filter current period data for. If omitted, returns data for all companies."
        }
      }
    }
  }]
};